export default {
      id: "partner-facebook-usage",
      viewBox: "0 0 16 16",
      url: "/" + "assets/sprite.svg#partner-facebook",
      toString: function () {
        return this.url;
      }
    }